import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  Grid,
  TextField,
  Paper,
  withStyles,
  Button,
  FormHelperText,
  Select,
  MenuItem,
  Typography,
} from '@material-ui/core';
import PageTitle from '../../components/PageTitle/PageTitle';
import FormInputLabel from '../../components/FormInputLabelView';
import MUIDataTable from 'mui-datatables';
import '../devices/styles/devicepage.css';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { clearLocalStorage } from '../../utils/common';
import { tenantInfo } from '../../utils/tenantInformation';

class WardsPage extends React.Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    // this.initData = this.initData;
    this.state = {
      tenants: [],
      data: {
        name: '',
        locationId: '',
        tenantId: '',
        description: '',
      },
      errorField: {
        name: false,
        locationId: false,
        tenantId: false,
      },
    };
  }
  async componentDidMount() {
    const tenants = tenantInfo();
    this.setState({ tenants });

    const { offset, limit, search, sort, order, tenantIds } = this.props.group.toJS();
    await this.props.group.getGroupCMSList(offset, limit, search, sort, order, tenantIds);
    await this.props.locations.getLocationList(0, 0);
    this.initData(tenants);

    const groupPath = this.props.location.pathname.replace('/app/groups/', '');
    const groupId = Number(groupPath.replace('/view', ''));

    await this.props.subGroup.getSubGroupByGroupID(groupId);
  }
  goBack() {
    this.props.group.setAction('action', true);
    this.props.history.goBack();
  }

  initData(tenants) {
    const { groupscms, tenantIds } = this.props.group.toJS();
    const groupPath = this.props.location.pathname.replace('/app/groups/', '');
    const groupId = Number(groupPath.replace('/edit', ''));
    const showGroupData = groupscms.data.find((item) => item.id === groupId);
    if (showGroupData) {
      this.setState({
        data: {
          id: showGroupData.id,
          name: showGroupData.name,
          locationId: showGroupData.locationId,
          tenantId: showGroupData.tenantId,
          description: showGroupData.description,
        },
      });
    } else {
      if (tenants.length === 1) {
        tenants.forEach((t) => {
          this.setState({ data: { tenantId: t.id } });
        });
      } else if (tenantIds && tenantIds.length === 1) {
        tenantIds.forEach((id) => {
          this.setState({ data: { tenantId: id } });
        });
      }
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState((prevState) => {
      prevState.data[name] = value;
      return prevState;
    });
  };

  handleCreateGroup = async (data) => {
    const { t } = this.props;
    if (this.validate()) {
      try {
        const result = await this.props.group.createGroup(data);
        if (result.statusCode === 200) {
          Swal.fire({
            html: `<h4>${t('create_success')}`,
            type: 'success',
          }).then(async (resultSuccess) => {
            if (resultSuccess.value) {
              this.props.history.push('../groups');
            } else {
              Swal.fire({
                html: `<h4>${t('failed_to_create')}`,
                type: 'error',
              });
            }
          });
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else if (e.statusCode === 400) {
          const msg = e.error.message || `${t('failed_to_create')}`;
          Swal.fire({ html: `<h4>${msg}`, type: 'error' });
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
        }
      }
    }
  };

  handleEditGroup = async (data) => {
    const { t } = this.props;
    if (this.validate()) {
      Swal.fire({
        html: `<h4>${t('edit_group')}`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: `${t('edit')}`,
        cancelButtonText: `${t('cancel')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          try {
            const result = await this.props.group.updateGroup(data);
            if (result.statusCode === 200) {
              Swal.fire({
                html: `<h4>${t('update_success')}`,
                type: 'success',
              }).then(async (resultSuccess) => {
                if (resultSuccess.value) {
                  this.props.group.setAction('action', true);
                  this.props.history.push('../../groups');
                } else {
                  Swal.fire({
                    html: `<h4>${t('failed_to_update')}`,
                    type: 'error',
                  });
                }
              });
            }
          } catch (e) {
            if (e.statusCode === 401) {
              clearLocalStorage();
              window.location.href = '/login';
            } else if (e.statusCode === 400) {
              const msg = e.error.message || `${t('failed_to_update')}`;
              Swal.fire({ html: `<h4>${msg}`, type: 'error' });
            } else {
              Swal.fire({
                html: `<h4>${t('failed_to_update')}`,
                type: 'error',
              });
            }
          }
        }
        // else if (result.dismiss === Swal.DismissReason.cancel) {
        //   Swal.fire({ html: "<h4>Cancelled <br/>This photo has not been edit. :)", type: "error" });
        // }
      });
    }
  };

  validate() {
    const { data } = this.state;
    if (!data.name || !data.locationId || !data.tenantId) {
      let checkName = !data.name ? true : false;
      let checkLocation = !data.locationId ? true : false;
      let checkTenant = !data.tenantId ? true : false;
      this.setState({
        errorField: {
          name: checkName,
          locationId: checkLocation,
          tenantId: checkTenant,
        },
      });
      return false;
    } else {
      this.setState({
        errorField: {
          name: false,
          locationId: false,
          tenantId: false,
        },
      });
    }
    return true;
  }

  clearErrorField(key) {
    if (key === 'name') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          name: false,
        },
      });
    }
    if (key === 'locationId') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          locationId: false,
        },
      });
    }
    if (key === 'tenantId') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          tenantId: false,
        },
      });
    }
  }

  renderFormCreate() {
    const { classes, t } = this.props;
    const { data, tenants } = this.state;
    const { locations, loading } = this.props.locations.toJS();
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('create_a_group')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.tenantId || ' '}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                >
                  <MenuItem fullwidth='true' key={9999999} value={' '}>
                    {t('please_select_tenant')}
                  </MenuItem>
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.tenantId : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('location')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.locationId || 0}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'locationId',
                    id: 'locationId',
                  }}
                >
                  <MenuItem fullwidth='true' key={0} value={0}>
                    {t('please_select_location')}
                  </MenuItem>
                  {(locations.data || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.locationId : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleCreateGroup(data)}
                  className={classes.button}
                >
                  {t('create')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderFormEdit() {
    const { classes, t } = this.props;
    const { data, tenants } = this.state;
    const { locations } = this.props.locations.toJS();
    return (
      <React.Fragment>
        <Paper className={classes.paper}>
          <PageTitle title={t('edit_a_group')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.tenantId || ' '}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                  disabled
                >
                  <MenuItem fullwidth='true' key={9999999} value={' '}>
                    {t('please_select_tenant')}
                  </MenuItem>
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.tenantId : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('location')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.locationId}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'locationId',
                    id: 'locationId',
                  }}
                >
                  {(locations.data || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.locationId : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleEditGroup(data)}
                  className={classes.button}
                >
                  {t('edit')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderView() {
    const { classes, t } = this.props;
    let { ListSubGroups, loading } = this.props.subGroup.toJS();
    ListSubGroups = (ListSubGroups || []).map((val) => {
      val.bedNo = val.beds.length || 0;
      val.map = val.map ? val.map : {};
      return val;
    });
    const { groupscms } = this.props.group.toJS();
    const groupPath = this.props.location.pathname.replace('/app/groups/', '');
    const id = Number(groupPath.replace('/view', ''));
    const showGroupData = groupscms.data.find((item) => item.id === id);
    const { locations } = this.props.locations.toJS();
    const columns = [
      {
        name: 'id',
        label: `${t('id')}`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'name',
        label: `${t('name')}`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{row[1]}</div>;
          },
        },
      },
      {
        name: 'bedNo',
        label: `${t('no_of_bed')}`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{row[2]}</div>;
          },
        },
      },
      {
        name: 'map.name',
        label: `${t('map')}`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{row[3]}</div>;
          },
        },
      },
    ];

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('view_a_group')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={showGroupData.tenantId || ' '}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                  disabled
                >
                  <MenuItem fullwidth='true' key={9999999} value={' '}>
                    {t('please_select_tenant')}
                  </MenuItem>
                  {(this.state.tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={showGroupData.name}
                variant='outlined'
                margin='dense'
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('location')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={showGroupData.locationId}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'locationId',
                    id: 'locationId',
                  }}
                  disabled
                >
                  {(locations.data || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={showGroupData.description}
                variant='outlined'
                margin='dense'
                disabled
              />
            </Grid>
          </Grid>
        </Paper>

        <div className={classes.TitlePage}>
          <Typography className={classes.typo} variant='h6'>
            {t('list_of_module')}
          </Typography>
        </div>
        <Grid container spacing={32} className={classes.mainContain}>
          <Grid item xs={12}>
            <MUIDataTable
              data={ListSubGroups}
              columns={columns}
              options={{
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: true,
                filterType: 'dropdown',
                responsive: 'scrollFullHeight',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <div className={classes.buttons}>
              <Button className={classes.button} onClick={this.goBack}>
                {t('back')}
              </Button>
            </div>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }

  render() {
    const path = this.props.match.path.replace('/app/groups/:id/', '');
    let result;
    switch (path) {
      case 'edit':
        result = this.renderFormEdit();
        break;
      case 'view':
        result = this.renderView();
        break;
      default:
        result = this.renderFormCreate();
        break;
    }
    return result;
  }
}

const styles = (theme) => ({
  mainContain: {
    padding: 16,
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  spaceTop: {
    marginTop: '10px',
  },
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: 20,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  formControl: {
    width: '100%',
  },
  TitlePage: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 4,
    background: '#049588',
    height: '90px',
    margin: '-24px',
  },
  typo: {
    color: 'white',
    padding: '30px',
  },
});
export const page = inject('group', 'locations', 'subGroup')(observer(WardsPage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
